import React from "react"
import styled from "styled-components"
import { ModalHeader } from "reactstrap"
import { StyledModal } from "../Prospect/PathBox/styles"
import AdditionalRequirementsList from "../MembershipJourney/AdditionalRequirementsList"

export const ADDITIONAL_REQUIREMENTS_MODAL_TITLE = "Additional Requirements"

const ModalBodyScroll = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  padding: 0 8px 16px;
`

const AdditionalRequirementsModal = ({ isOpen, onClose, items }) => (
  <StyledModal isOpen={isOpen} toggle={onClose} centered size="lg">
    <ModalHeader toggle={onClose}>
      {ADDITIONAL_REQUIREMENTS_MODAL_TITLE}
    </ModalHeader>
    <ModalBodyScroll>
      <AdditionalRequirementsList
        items={items}
        collapsible={false}
        showSectionHeader={false}
      />
    </ModalBodyScroll>
  </StyledModal>
)

export default AdditionalRequirementsModal
